var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryServices = function SvgCategoryServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "category_services_svg__Layer_3_1_",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".category_services_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "category_services_svg__st0",
    d: "M24.5 13.2h5.6c.7 0 1.4.3 1.8.9l.3.4c.3.3.5.8.5 1.3v.5c0 .6.2 1 .6 1.4l2.3 2c.6.5.9 1.2.9 1.9v9.8c0 .6-.2 1.4-.6 1.8h0c-.2.3-.6.4-.9.4h-6.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "category_services_svg__st0",
    d: "m33 17-4.2 4.7-2.4-4.7 5.3-3.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "category_services_svg__st0",
    d: "m24.5 37.5 3.5-3.9-1.9-11.7 1.7-2.3M24.5 13.2h-5.6c-.7 0-1.4.3-1.8.9l-.3.4c-.3.3-.5.8-.5 1.3v.5c0 .6-.2 1-.6 1.4l-2.3 2c-.6.5-.9 1.2-.9 1.9v9.8c0 .6.2 1.4.6 1.8h0c.3.3.6.4.9.4h6.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "category_services_svg__st0",
    d: "m16 17 4.1 4.7 2.4-4.7-5.2-3.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "category_services_svg__st0",
    d: "m24.5 37.5-3.6-3.9 2-11.7-1.8-2.3M26.4 17h-3.9M22.9 21.9h3.2"
  })));
};
export default SvgCategoryServices;